import { observer } from "mobx-react-lite";
import { RemoveNotesFromSharedCollectionModalStore } from "@/components/modal/remove-notes-from-shared-collection/remove-notes-from-shared-collection-modal-store";
import { NoteChip } from "@/components/chips/note-chip";
import { useMemo } from "react";
import { hasAccessToNoteAfterRemovingFromCollection } from "@/store/sync/operations/helpers/collections";
import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";

export interface RemoveNoteFromSharedCollectionModalProps {
  store: RemoveNotesFromSharedCollectionModalStore;
}

export const RemoveNotesFromSharedCollectionModal =
  observer<RemoveNoteFromSharedCollectionModalProps>(({ store }) => {
    const isMultipleNotes = store.notes.length > 1;

    const removeWarningText = useMemo(() => {
      if (store.notes.length > 1)
        return "By removing these notes from the collection, you and others may lose access.";
      if (!store.notes[0] || !store.collection)
        return "By removing this note from the collection, you and others may lose access.";
      if (
        hasAccessToNoteAfterRemovingFromCollection({
          store: store.store,
          note: store.notes[0],
          collection: store.collection,
        })
      ) {
        return "By removing this note from the collection, others may lose access.";
      } else {
        return "By removing this note from the collection, you and others may lose access.";
      }
    }, [store.notes, store.collection, store.store]);

    if (!store.notes.length || !store.collection) return null;
    return (
      <MDSModalDialog
        isOpen={store.isOpen && !!store.notes.length && !!store.collection}
        handleClose={() => store.close()}
      >
        <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
          Remove {isMultipleNotes ? "notes" : <NoteChip title={store.notes[0].title} inline />} from
          collection?
        </MDSText>

        <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
          <MDSText variant={MDSTextVariant.ParagraphS}>{removeWarningText}</MDSText>
        </MDSDialogTextContent>

        <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
          <MDSButton onClick={() => store.close()}>Cancel</MDSButton>
          <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={() => store.handleSubmit()}>
            Remove {isMultipleNotes ? "notes" : "note"}
          </MDSButton>
        </MDSButtonGroup>
      </MDSModalDialog>
    );
  });
